import React, { memo } from 'react';
import { Box, Heading, Text, Button, Stack, Icon, LinkBox, LinkOverlay, UnorderedList, ListItem } from '@chakra-ui/react';
import { ExternalLink, MessageSquare, Search, Flame, Mic, Zap, Code, BookOpen, Heart, Mail } from 'lucide-react';
interface ToolCardProps {
  name: string;
  description: string;
  features: string[];
  link: string;
  index: number;
  icon: any;
  color: string;
  isFeatured?: boolean;
}
const getToolIcon = (name: string) => {
  const iconMap: {
    [key: string]: {
      icon: any;
      color: string;
    };
  } = {
    ChatGPT: {
      icon: MessageSquare,
      color: '#10a37f'
    },
    'Perplexity & Comet': {
      icon: Search,
      color: '#6366f1'
    },
    'Firebase Studio': {
      icon: Flame,
      color: '#ffa000'
    },
    'Wispr Flow': {
      icon: Mic,
      color: '#8b5cf6'
    },
    'Bolt.new': {
      icon: Zap,
      color: '#f59e0b'
    },
    Replit: {
      icon: Code,
      color: '#f26207'
    },
    'Google Notebook LM': {
      icon: BookOpen,
      color: '#4285f4'
    },
    Lovable: {
      icon: Heart,
      color: '#ec4899'
    },
    Superhuman: {
      icon: Mail,
      color: '#000000'
    }
  };
  return iconMap[name] || {
    icon: Code,
    color: '#6b7280'
  };
};
export const ToolCard = memo(function ToolCard({
  name,
  description,
  features,
  link
}: ToolCardProps) {
  const toolStyle = getToolIcon(name);
  return <LinkBox as="article" height="100%" data-id="element-136">
      <Box bg="white" borderRadius="lg" overflow="hidden" shadow="md" _hover={{
      shadow: 'lg',
      transform: 'translateY(-2px)'
    }} transition="all 0.3s" height="100%" display="flex" flexDirection="column" data-id="element-137">
        <Box bg={`${toolStyle.color}15`} p={6} display="flex" alignItems="center" justifyContent="center" height="120px" data-id="element-138">
          <Icon as={toolStyle.icon} boxSize={12} color={toolStyle.color} data-id="element-139" />
        </Box>
        <Stack spacing={3} p={6} flex="1" data-id="element-140">
          <Heading as="h3" size="md" data-id="element-141">
            {name}
          </Heading>
          <Text fontSize="sm" color="gray.600" flex="1" data-id="element-142">
            {description}
          </Text>
          <UnorderedList spacing={1} pl={4} data-id="element-143">
            {features.map((feature, idx) => <ListItem key={idx} fontSize="sm" data-id="element-144">
                {feature}
              </ListItem>)}
          </UnorderedList>
          <Box pt={2} data-id="element-145">
            <LinkOverlay href={link} isExternal data-id="element-146">
              <Button position="relative" overflow="hidden" bgGradient="linear(to-r, #1E73BE, #1a5fa0)" color="white" size="sm" rightIcon={<ExternalLink size={14} data-id="element-148" />} width="100%" shadow="sm" _before={{
              content: '""',
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              bgGradient: 'linear(to-r, #2c0842, #1E73BE)',
              opacity: 0,
              transition: 'opacity 0.6s ease-in-out',
              zIndex: -1
            }} _hover={{
              shadow: 'lg',
              _before: {
                opacity: 1
              }
            }} data-id="element-147">
                Try {name}
              </Button>
            </LinkOverlay>
          </Box>
        </Stack>
      </Box>
    </LinkBox>;
});